/** Observaciones del navegador; nunca son autoridad de pago ni de reserva. */
export const CHECKOUT_CLIENT_EVENTS = [
  'button_mounted', 'button_clicked', 'script_load_error', 'button_missing', 'checkout_left',
  'edit_details', 'whatsapp_selected', 'confirmation_returned', 'checkout_open_error',
] as const;
export type CheckoutClientEvent = typeof CHECKOUT_CLIENT_EVENTS[number];
export interface CheckoutObservation { id: string; type: CheckoutClientEvent }
export const CHECKOUT_REFERENCE_RE = /^PCT-TOUR-[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function parseCheckoutObservation(input: unknown): CheckoutObservation | null {
  if (!input || typeof input !== 'object') return null;
  const { id, type } = input as Record<string, unknown>;
  if (typeof id !== 'string' || !UUID_RE.test(id) ||
      typeof type !== 'string' || !CHECKOUT_CLIENT_EVENTS.includes(type as CheckoutClientEvent)) return null;
  // Whitelist: no nombres, correos, mensajes del proveedor, URL ni campos de tarjeta.
  return { id, type: type as CheckoutClientEvent };
}

/** Escritura atómica, acotada y aislada: ni siquiera toca payment_status. */
export const APPEND_CHECKOUT_TRACE_SQL = `UPDATE pac_tour_checkout_orders
 SET checkout_trace = (
   SELECT COALESCE(jsonb_agg(item ORDER BY position), '[]'::jsonb)
   FROM jsonb_array_elements(checkout_trace || jsonb_build_array(
     jsonb_build_object('id', $5::text, 'type', $6::text, 'source', $7::text, 'received_at', now())
   )) WITH ORDINALITY AS entries(item, position)
   WHERE position > GREATEST(0, jsonb_array_length(checkout_trace) + 1 - 60)
 )
 WHERE public_reference = $1 AND company_id = $2 AND brand_id = $3
   AND merchant_id_expected = $4
   AND created_at > now() - INTERVAL '7 days'
   AND NOT checkout_trace @> jsonb_build_array(jsonb_build_object('id', $5::text))
 RETURNING id`;
